import React from 'react'
import { Edit } from 'react-admin'
import WithDeleteModalToolbar from 'ui-shared/CustomToolbars/WithDeleteModalToolbar'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import KampaayerForm from './KampaayerForm'

const KampaayerEdit: React.FC = () => {
  return (
    <SectionWrapper>
      <Edit>
        <KampaayerForm toolbar={<WithDeleteModalToolbar />} />
      </Edit>
    </SectionWrapper>
  )
}

export default KampaayerEdit
